import { render } from "./QuizQCM.vue?vue&type=template&id=0d3042f2"
import script from "./QuizQCM.vue?vue&type=script&lang=js"
export * from "./QuizQCM.vue?vue&type=script&lang=js"
script.render = render

export default script